import type { Address } from "viem";
import { blockchain, ZERO_ADDRESS, TESTING_MODE } from "./networkData";

export type RewardTokenCategory = "primary" | "stablecoin" | "crypto" | "stock" | "etf" | "commodity" | "meme" | "other";

export interface WhitelistedRewardToken {
  address: Address;
  name: string;
  type: RewardTokenCategory;
}

const arcadeAddress = blockchain.arcade_address as Address;

export function shortTokenLabel(address: string): string {
  if (!address || address.length < 10) return address || "Token";
  return `${address.slice(0, 6)}…${address.slice(-4)}`;
}

export function getWhitelistedRewardTokens(_chainId: number): WhitelistedRewardToken[] {
  // Testnet 
  if (TESTING_MODE) {
    const tokens: WhitelistedRewardToken[] = [
      { address: ZERO_ADDRESS as Address, name: "USD", type: "primary" },
    ];
    // if (arcadeAddress.toLowerCase() !== ZERO_ADDRESS.toLowerCase()) {
    //   tokens.push({ address: arcadeAddress, name: "ARCADE", type: "crypto" });
    // }

    tokens.push({ address: "0x89B50855Aa3bE2F677cD6303Cec089B5F319D72a", name: "EURC", type: "stablecoin" });
    tokens.push({ address: "0xf0C4a4CE82A5746AbAAd9425360Ab04fbBA432BF", name: "Circle BTC", type: "crypto" });
    tokens.push({ address: "0x5A63C27611780c01980b7F5f150acdC3D92b434d", name: "PONS", type: "crypto" });
    tokens.push({ address: "0xE421f7A82379C9EeEFb4c47D9Dc44D2Dd514954C", name: "VIRTUAL", type: "crypto" });
    tokens.push({ address: "0xF4cA5adcc58Ee0aCb3E442a6c5058f381B2F8E96", name: "SoulOfSparta", type: "meme" });
    tokens.push({ address: "0x4c84B8B50a66bbc512C0154C4a16BA909789A8A3", name: "SpaceX", type: "stock" });
    tokens.push({ address: "0x7DeA875A4D644aB78e0914FFF8b760bE5e8F54cb", name: "Aurum", type: "meme" });
    tokens.push({ address: "0x8ccFf7D6bCC1edC497a66FB5bd699f0d6E763f52", name: "Bundle Cat", type: "meme" });
    tokens.push({ address: "0x544435fF26f40391242E73ac1BB29D8F08b1CDdd", name: "Frosh", type: "meme" });
    tokens.push({ address: "0x408E71D4aBb816154b83B8a4333770cb076FaE6d", name: "Bundle PEPE", type: "meme" });
    tokens.push({ address: "0x0476E6f625c338860C6c89b322A607903C888FaA", name: "Apple", type: "stock" });
    tokens.push({ address: "0x89a0Fb4a36b1Bd4300e1f549DC7DbEaA2489EcA1", name: "Amazon", type: "stock" });
    tokens.push({ address: "0xDdA4416145AE4AF5A50CE9dB4D30747C3d54Ee2A", name: "QQQ", type: "etf" });
    tokens.push({ address: "0xE8AcA1a5F2beE2526093F38BD575396A4F078d04", name: "Gold", type: "commodity" });
    tokens.push({ address: "0xa217Db7F759827Ce2A4d568027B64C4512f51D01", name: "Silver", type: "commodity" });
    tokens.push({ address: "0x348E6abE560476AE5c60ba4D7Eb4B0D945b0126D", name: "Tesla", type: "stock" });
    tokens.push({ address: "0x10A97B7a1181612FD7e9EEFC5B7f0635e6eb63C8", name: "Meta", type: "stock" });
    tokens.push({ address: "0x4896DE7Fc291edE3fD11073fC4Ea2974dD6dB6Cb", name: "Google", type: "stock" });
    tokens.push({ address: "0x8D94f51712122D7deBEb3F5d73FAa37ED79f0B13", name: "Microsoft", type: "stock" });


    return tokens;
  } else {
    const tokens: WhitelistedRewardToken[] = [
      { address: ZERO_ADDRESS as Address, name: "Ethereum", type: "crypto" },
    ];
    // if (arcadeAddress.toLowerCase() !== ZERO_ADDRESS.toLowerCase()) {
    //   tokens.push({ address: arcadeAddress, name: "ARCADE", type: "crypto" });
    // }


    tokens.push({ address: "0x07EBB29a38Fbcb41563817e5E19f2ceC619C90D2", name: "BUN", type: "primary" });
    tokens.push({ address: "0x5fc5360d0400a0fd4f2af552add042d716f1d168", name: "USDG", type: "stablecoin" });
    tokens.push({ address: "0x322f0929c4625ed5bad873c95208d54e1c003b2d", name: "TSLA", type: "stock" });
    tokens.push({ address: "0x39dbed3a2bd333467115de45665cc57f813c4571", name: "PONS", type: "crypto" });
    tokens.push({ address: "0xB6ff957E31286F748989Cbf69183b1b5e8d921A8", name: "CONV", type: "crypto" });
    tokens.push({ address: "0x56910D4409F3a0C78C64DD8D0545FF0705389870", name: "INDEX", type: "crypto" });
    tokens.push({ address: "0xBf818eFe65aac127AC8f9Fec6fEC203ee222C851", name: "BPEPE", type: "meme" });
    tokens.push({ address: "0x25db3541FCB9c41B1CA05b665a260D9d094B4B9C", name: "BEBIR", type: "meme" });
    tokens.push({ address: "0xc9a981fee1f9dec688bb123ccdecc63d0debfc4e", name: "GLD", type: "commodity" });
    tokens.push({ address: "0x411efb0e7f985935daec3d4c3ebaea0d0ad7d89f", name: "SLV", type: "commodity" });
    tokens.push({ address: "0xd5f3879160bc7c32ebb4dc785f8a4f505888de68", name: "QQQ", type: "etf" });

    return tokens;

  }
}

export function getWhitelistedTokensByCategory(chainId: number): Record<RewardTokenCategory, WhitelistedRewardToken[]> {
  return getWhitelistedRewardTokens(chainId).reduce<Record<RewardTokenCategory, WhitelistedRewardToken[]>>(
    (groups, token) => {
      groups[token.type].push(token);
      return groups;
    },
    { primary: [], stablecoin: [], crypto: [], stock: [], etf: [], commodity: [], meme: [], other: [] },
  );
}

export function getTokenName(_chainId: number, address: Address): string | null {
  return getWhitelistedRewardTokens(blockchain.chainId).find(
    (token) => token.address.toLowerCase() === address.toLowerCase(),
  )?.name ?? null;
}

export function resolveRewardTokenLabel(chainId: number, address: Address): string {
  return getTokenName(chainId, address) ?? shortTokenLabel(address);
}